function escapeCsv(value: unknown): string {
  if (value === null || value === undefined) return '';
  const text = String(value);
  return /[",\n\r;]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

/**
 * Descarga un CSV UTF-8 con BOM para que Excel respete tildes y eñes.
 * Los valores se exportan crudos (ISO y números) para que la hoja sea filtrable.
 */
export function downloadCsv(
  filename: string,
  headers: Array<{ key: string; label: string }>,
  rows: Array<Record<string, unknown>>,
): void {
  const lines = [
    headers.map((header) => escapeCsv(header.label)).join(','),
    ...rows.map((row) => headers.map((header) => escapeCsv(row[header.key])).join(',')),
  ];
  const blob = new Blob(['\uFEFF' + lines.join('\r\n')], {
    type: 'text/csv;charset=utf-8',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
